import moment from "moment";
import { useEffect, useState } from "react";
const ProductCountdown = ({ item, val }) => {
  const [data, setData] = useState(item);
  const [timeLeft, setTimeLeft] = useState("");
  const calculateTimeLeft = () => {
    const now = moment(); // Current time
    const publishDate = moment(
      item?.ToPushlishDate || item?.ProductToPublishDate || item?.EndDate || item?.DealPriceDeclareDate
    ); // Product publish date
    if (publishDate.isValid()) {
      const timeDifference = publishDate.diff(now);
      if (timeDifference <= 0) {
        setTimeLeft("");
      } else {
        const duration = moment.duration(timeDifference);
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();
        setTimeLeft(`${days}D : ${hours}H : ${minutes}M : ${seconds}S`);
      }
    } else {
      setTimeLeft("Date is not set");
    }
  };
  useEffect(() => {
    if (item?.ToPushlishDate || item?.ProductToPublishDate || item?.EndDate || item?.DealPriceDeclareDate) {
      // Start the timer when component mounts
      const timer = setInterval(calculateTimeLeft, 1000);
      // Cleanup interval on component unmount
      return () => clearInterval(timer);
    }
  }, [item]);
  return (
    <>
      {val === "detail" ? (
        <h3>{timeLeft}</h3>
      ) : val === "tillTime" ? (
        <p>
          Till: {timeLeft}
        </p>
      ) : val === "tymleft" ? (
        <div>{timeLeft}</div>
      ) : val === "referral" ? (
        <>{timeLeft?.split(":")?.join("").toLocaleLowerCase()}</>
      ) : val === "checkTime" ? (
        <>Till: {timeLeft}</>
      ) : (
        <h4>{timeLeft}</h4>
      )}
    </>
  );
};
export default ProductCountdown;
